<template>
  <section>
    <div class="align">
      <h1>Преимущества<br/>
        микрозаймов ФИНМОЛЛ</h1>
      <ul>
        <li>
          <div>
            <IconBase :viewBox="'0 0 46 46'">
              <UserSingle></UserSingle>
            </IconBase>
          </div>
          <p>Необходим только паспорт РФ</p>
        </li>
        <li>
          <div>
            <IconBase :viewBox="'0 0 45 45'">
              <Bank></Bank>
            </IconBase>
          </div>
          <p>Не требуется кредитная история</p>
        </li>
        <li>
          <div>
            <IconBase :viewBox="'0 0 46 46'">
              <Interface></Interface>
            </IconBase>
          </div>
          <p>Полное отсутствие штрафов</p>
        </li>
        <li>
          <div>
            <IconBase :viewBox="'0 0 46 46'">
              <Users></Users>
            </IconBase>
          </div>
          <p>Наш агент сам приедет к Вам домой</p>
        </li>
        <li>
          <div>
            <IconBase :viewBox="'0 0 39 41'">
              <Calendar></Calendar>
            </IconBase>
          </div>
          <p>Деньги на счет поступят в день обращения</p>
        </li>
        <li>
          <div>
            <IconBase :viewBox="'0 0 40.173 39'">
              <DealBack></DealBack>
            </IconBase>
          </div>
          <p>Возвратная сумма прописана в договоре и не меняется</p>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
  export default {
    name: "advantages",
    components: {
      IconBase: () => import('@/components/svg/IconBase'),
      UserSingle: () => import('@/components/svg/adv_users_sungle'),
      Users: () => import('@/components/svg/adv_users'),
      Interface: () => import('@/components/svg/adv_interface-essential-114'),
      DealBack: () => import('@/components/svg/adv_dealBack'),
      Calendar: () => import('@/components/svg/adv_calendar'),
      Bank: () => import('@/components/svg/adv_bank'),
    }
  }
</script>

<style scoped>
  section{background-color: #F9F9F8;padding: 14vw 0 4.7vw;}
  h2 {}
  ul {}
  li {display: flex;align-items: center;justify-content: space-between;margin: 8vw 0;}
  li > div {width: 30vw;height: 30vw;display: flex;align-items: center;justify-content: center; box-shadow: 0px 11px
  25px 0px #E1E6EB;
    border-radius: 100%;background: white;}
  li > div > svg {width: 14.1vw;height: 14.1vw;}
  li > p {font-size: 5vw;width: calc(100% - 35vw);}
  @media screen and (min-width: 760px) {
    section{padding: 4vw 0 1.3vw;}
    ul {display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap;}
    li {width: 28%;margin: 3.5vw 0;}
    li > div {width: 8.5vw;height: 8.5vw;}
    li > div > svg {width: 4vw;height: 4vw;}
    li > p {font-size: 1.4vw;width: calc(100% - 10vw);}
  }
  @media screen and (min-width: 1140px) {
    section{padding: 45px 0 15px;}
    h2 {font-size: 40px}
    ul {}
    li {margin: 40px 0;}
    li > div {width: 96px;height: 96px;}
    li > div > svg {width: 45px;height: 45px;}
    li > p {font-size: 16px;width: calc(100% - 115px);}
  }
</style>
